import { Fragment } from 'react';

import { CONTROL_TYPE } from '../../../utils/constants';
import Control from '../../Control';
import type { AddressFieldConfig } from '../types';

interface AddressBuilderProps {
  /** Name of address category (soldToAddress, billToAddress, etc). */
  name: string;
  /** Array of address fields (street, city, etc). */
  addressFields?: AddressFieldConfig[];
}

/**
 * This Component generates address fields for the category name passed as a prop.
 */
function AddressBuilder({ name, addressFields = [] }: AddressBuilderProps) {
  const controlType: Record<string, string> = {
    street: CONTROL_TYPE.addressAutoComplete,
    city: CONTROL_TYPE.addressField,
    state: CONTROL_TYPE.stateSelect,
    zipCode: CONTROL_TYPE.addressField,
    country: CONTROL_TYPE.select,
    naturalPerson: CONTROL_TYPE.checkbox,
    taxNumber1: CONTROL_TYPE.addressField,
    district: CONTROL_TYPE.addressField
  };
  const controls = addressFields.map(item => {
    const key = `${name}.${item.field}`;
    const props = {
      name: key,
      required: item.required,
      label: item.label,
      validations: item.validations,
      placeholder:
        item.additionalProps && item.additionalProps.placeholder ? item.additionalProps.placeholder : item.label,
      type: item.type === 'citySelect' ? 'citySelect' : controlType[item.field],
      options: item.options,
      footer: item.additionalProps && item.additionalProps.footer,
      disabled: item.disabled
    };
    return item.Wrapper ? (
      <item.Wrapper key={key}>
        <Control {...props} />
      </item.Wrapper>
    ) : (
      <Control key={key} {...props} />
    );
  });

  return <Fragment>{controls}</Fragment>;
}

export default AddressBuilder;
